import React, { useEffect, useState } from 'react'
import { useMap } from 'react-map-gl/maplibre'

import { Crosshairs } from '@/components/icons'

import { CenterLocation } from './map-component.styles'

interface Props {
  center: { lat: string; lng: string }
  setDefaultCurrentPoint: () => void
}

const CenterOnBuilding = ({ center, setDefaultCurrentPoint }: Props) => {
  const { current: map } = useMap()
  const buildingLat = Number(center.lat)
  const buildingLng = Number(center.lng)
  const [position, setPosition] = useState({
    lat: buildingLat,
    lng: buildingLng
  })
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (!map) return
    const handler = () => {
      setPosition({
        lat: map.getCenter().lat,
        lng: map.getCenter().lng
      })
    }
    map.on('moveend', handler)
    return () => {
      map.off('moveend', handler)
    }
  }, [buildingLat, buildingLng, map])

  useEffect(() => {
    if (
      Number(position.lat).toFixed(5) !== buildingLat.toFixed(5) &&
      Number(position.lng).toFixed(5) !== buildingLng.toFixed(5)
    ) {
      setShow(true)
    } else {
      setShow(false)
    }
  }, [buildingLat, buildingLng, position])

  const handleClick = () => {
    map?.flyTo({
      center: { lng: buildingLng, lat: buildingLat },
      zoom: 18,
      animate: true,
      duration: 0.4
    })
    setPosition({
      lat: buildingLat,
      lng: buildingLng
    })
    setDefaultCurrentPoint()
    setShow(false)
  }

  return (
    <div>
      {show && (
        <CenterLocation>
          <button
            aria-label="Center map on listing"
            title="Center map on listing"
            onClick={handleClick}
          >
            <Crosshairs width={20} />
          </button>
        </CenterLocation>
      )}
    </div>
  )
}
export default CenterOnBuilding
